/**
 * Opens Mercado Pago Checkout Pro using the official SDK when possible,
 * falling back to a direct redirect to the checkout URL returned by the backend.
 */
export async function openMercadoPagoCheckout({ sdk, preferenceId, checkoutUrl }) {
  if (!checkoutUrl && !preferenceId) {
    throw new Error('Checkout do Mercado Pago indisponível');
  }

  if (checkoutUrl) {
    window.location.assign(checkoutUrl);
    return;
  }

  if (sdk && preferenceId && typeof sdk.checkout === 'function') {
    sdk.checkout({
      preference: { id: preferenceId },
      autoOpen: true,
    });
    return;
  }

  throw new Error('Checkout do Mercado Pago indisponível');
}
